import React, { useEffect, useState } from "react";
import { clearLocalIdentity, validateCentralSession } from "./identitySession";
import { consumeIdentityDestination } from "./identityClient";

export default function IdentityBootstrap({ children }) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let active = true;
    const bootstrap = async () => {
      const params = new URLSearchParams(window.location.search);
      const userId = params.get("userId");
      const refreshToken = params.get("refreshToken");
      if (userId && refreshToken) {
        try {
          const body = new FormData(); body.append("id", userId);
          const response = await fetch("https://api.accounts.clikkle.com/api/auth/get_user_profile", { method: "POST", body });
          const data = await response.json();
          if (response.ok && data?.user) {
            localStorage.setItem("user", JSON.stringify(data.user));
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("token", refreshToken);
            const url = new URL(window.location.href); url.searchParams.delete("userId"); url.searchParams.delete("refreshToken");
            window.history.replaceState({}, "", url.toString());
            const destination = consumeIdentityDestination("");
            if (destination && destination !== "/" && destination !== window.location.pathname) {
              window.location.replace(destination);
              return;
            }
          }
        } catch { clearLocalIdentity(); }
      }
      if (active) setReady(true);
    };
    bootstrap();
    const revalidate = async () => { if (localStorage.getItem("refreshToken")) await validateCentralSession(); };
    const onVisibility = () => { if (!document.hidden) revalidate(); };
    window.addEventListener("focus", revalidate); document.addEventListener("visibilitychange", onVisibility);
    return () => { active=false; window.removeEventListener("focus", revalidate); document.removeEventListener("visibilitychange", onVisibility); };
  }, []);
  return ready ? children : <div style={{minHeight:"100vh",background:"#111"}} aria-label="Restoring secure session"/>;
}
